import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { api } from "../lib/api";
import { Lock, User } from "lucide-react";
import { toast } from "sonner";

export default function LoginScreen() {
  const { login } = useAuth();
  const [appName, setAppName] = useState("Rental Tracker");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get("/settings/public").then((r) => setAppName(r.data.app_name)).catch(() => {});
  }, []);

  const handle = async (e) => {
    e.preventDefault();
    if (!username || !password) return;
    setBusy(true);
    try {
      await login(username, password);
      toast.success("Signed in successfully");
    } catch (err) {
      const detail = err.response?.data?.detail || "Authentication failed";
      toast.error(detail);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-gradient-to-br from-[#F5F5F7] via-white to-[#EDF1F7]" data-testid="login-screen">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex w-14 h-14 rounded-2xl bg-[#1C3A5E] items-center justify-center mb-4 shadow-lg shadow-[#1C3A5E]/20">
            <Lock className="text-white" size={26} />
          </div>
          <div className="text-[11px] uppercase tracking-[0.22em] text-[#86868B] font-semibold">{appName}</div>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight mt-2">
            Welcome back
          </h1>
          <p className="text-sm text-[#86868B] mt-2">
            Sign in with your username or email address.
          </p>
        </div>

        <form onSubmit={handle} className="card p-6 sm:p-8 space-y-4" data-testid="login-form">
          <div>
            <label className="label">Username or Email</label>
            <input
              type="text"
              data-testid="login-username-input"
              className="lapen-input"
              placeholder="Enter username or email address"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
              autoFocus
              required
            />
          </div>
          <div>
            <label className="label">Password</label>
            <input
              type="password"
              data-testid="login-password-input"
              className="lapen-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
              required
            />
          </div>
          <button
            type="submit"
            disabled={busy}
            data-testid="login-submit-button"
            className="btn-primary w-full"
          >
            {busy ? "Signing in…" : "Sign in"}
          </button>
          <div className="text-center pt-2">
            <p className="text-xs text-[#86868B]">
              Don&apos;t have an account?{" "}
              <Link
                to="/signup"
                className="font-semibold text-[#1C3A5E] hover:underline"
              >
                Create new portfolio
              </Link>
            </p>
          </div>
          <p className="text-[11px] text-[#86868B] text-center pt-1 flex items-center justify-center gap-1.5">
            <User size={11} /> Multi-user · bcrypt · session-tracked
          </p>
        </form>
      </div>
    </div>
  );
}
